<mat-nav-list class="wzb-bo-navmenu navmenu" [class.navmenu--reduced]="reduced">
  <div class="wzb-bo-navmenu__menu-logo">
    <ng-content select="[menuLogo]" />
  </div>

  <nav class="navmenu__links">
    @for (item of items; track item.route.toString()) {
      <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
      <a
        class="wzb-bo-navmenu__link navmenu__link"
        [class.wzb-bo-navmenu__link--selected]="(activeRoute | toString) === (item.route | toString)"
        [matTooltip]="item.label"
        [matTooltipDisabled]="!reduced"
        (click)="onItemClick(item)"
        matRipple
        matTooltipPosition="right"
      >
        @if (item.icon) {
          <span class="navmenu__link__icon">
            <ng-container [ngTemplateOutlet]="iconTemplateMap[item.icon]" />
          </span>
        }
        @if (!reduced) {
          <div class="link__text">{{ item.label }}</div>
        }
      </a>
    }
  </nav>

  <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
  <div class="navmenu__links navmenu__footer" [style.margin-bottom]="footerActionsBottomMargin">
    @for (action of actions; track action.id.toString()) {
      <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
      <a
        class="navmenu__link wzb-bo-navmenu__footer__link"
        [matTooltip]="action.label"
        [matTooltipDisabled]="!reduced"
        [matRippleDisabled]="!action.label"
        [class.navmenu__footer__link--round]="!action.label"
        (click)="onActionClick(action)"
        matRipple
        matTooltipPosition="right"
      >
        @if (action.icon) {
          <span class="navmenu__link__icon" [matRippleDisabled]="!!action.label" matRipple>
            <ng-container [ngTemplateOutlet]="iconTemplateMap[action.icon]" />
          </span>
        }
        @if (action.iconText) {
          <span class="navmenu__link__icon" [matMenuTriggerFor]="menu">
            {{ action.iconText }}
          </span>
        }
        <mat-menu class="navmenu__link__panel" #menu="matMenu">
          @for (menuItem of action.menuItems; track menuItem.id) {
            <button (click)="onMenuItemClick(menuItem.id)" mat-menu-item type="button">
              {{ menuItem.label }}
            </button>
          }
        </mat-menu>
        @if (!reduced && !!action.label) {
          <div class="link__text">{{ action.label }}</div>
        }
      </a>
    }

    <div class="navmenu__option">
      <ng-content select="[menuOption]" />
    </div>
  </div>

  @if (reducible && reduceMode === 'classic') {
    <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
    <div class="navmenu__footer__toggle" (click)="toggle()">
      {{ reduced ? 'Agrandir' : 'Fermer' }}
    </div>
  }

  @if (reducible && reduceMode === 'arrow') {
    <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles, @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
    <div class="navmenu__footer__arrow-toggle" [style.top]="toggleArrowTopPosition" (click)="toggle()">
      <svg
        class="reduce-icon"
        [class.reduce-icon--expanded]="!reduced"
        width="5"
        height="8"
        viewbox="0 0 5 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1 7.333A.666.666 0 01.53 6.195l2.204-2.203-2.12-2.195a.667.667 0 01.96-.927l2.574 2.667a.667.667 0 01-.008.934L1.472 7.138c-.13.13-.3.195-.471.195z"
          fill="#fff"
        />
      </svg>
    </div>
  }
</mat-nav-list>
